module.exports = __webpack_public_path__ + "assets/asset_bed.dc4345b4.svg";